import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, FeaturesConfigModule, I18nModule, provideDefaultConfig, UrlModule } from '@spartacus/core';
import { ProductVariantsModule } from '@spartacus/product/variants';
import { defaultViewConfig, ItemCounterModule, MediaModule, OutletModule, ProductListModule, SpinnerModule, TotalModule, ViewConfig } from '@spartacus/storefront';
import { CustomCategorySummaryModule } from '../../../../../custom/cms-components/content/custom-category-summary/custom-category-summary.module';
import { CustomProductItemModule } from '../../../../../custom/cms-components/content/custom-product-item/custom-product-item.module';
import { CustomIconsModule } from '../../../../../custom/icons/custom-icons.module';
import { CustomPaginationModule } from '../../../shared/components/custom-pagination/custom-pagination.module';
import { CustomStarRatingModule } from '../../../shared/components/custom-star-raiting/custom-star-rating.module';
import { CustomAddToCartModule } from '../../cart/custom-add-to-cart/custom-add-to-cart.module';
import { CustomProductListComponent } from './container/custom-product-list.component';
import { CustomProductScrollComponent } from './container/custom-product-scroll/custom-product-scroll.component';
import { CustomProductGridItemComponent } from './product-grid-item/custom-product-grid-item.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        MediaModule,
        CustomAddToCartModule,
        ItemCounterModule,
        TotalModule,
        UrlModule,
        I18nModule,
        CustomStarRatingModule,
        CustomIconsModule,
        SpinnerModule,
        ProductVariantsModule,
        FeaturesConfigModule,
        OutletModule,
        CustomProductItemModule,
        CustomCategorySummaryModule,
        CustomPaginationModule,
        ConfigModule.withConfig({
            cmsComponents: {
                CMSProductListComponent: {
                    component: CustomProductListComponent,
                },
                ProductGridComponent: {
                    component: CustomProductListComponent,
                },
                SearchResultsListComponent: {
                    component: CustomProductListComponent,
                },
            },
        } as CmsConfig),
        ProductListModule,
    ],
    providers: [
        provideDefaultConfig(defaultViewConfig as ViewConfig),
    ],
    declarations: [
        CustomProductListComponent,
        CustomProductGridItemComponent,
        CustomProductScrollComponent
    ],
    exports: [
        CustomProductListComponent,
        CustomProductGridItemComponent,
        CustomProductScrollComponent
    ]
})
export class CustomProductListModule { }
